(function (e) {
  if (typeof exports === "object" && typeof module !== "undefined") {
    module.exports = e();
  } else if (typeof define === "function" && define.amd) {
    define([], e);
  } else {
    var t;

    if (typeof window !== "undefined") {
      t = window;
    } else if (typeof global !== "undefined") {
      t = global;
    } else if (typeof self !== "undefined") {
      t = self;
    } else {
      t = this;
    }

    t.midimessage = e();
  }
})(function () {
  var e, t, s;
  return function o(e, t, s) {
    function a(n, i) {
      if (!t[n]) {
        if (!e[n]) {
          var l = typeof require == "function" && require;
          if (!i && l) return l(n, !0);
          if (r) return r(n, !0);
          var h = new Error("Cannot find module '" + n + "'");
          throw h.code = "MODULE_NOT_FOUND", h;
        }

        var c = t[n] = {
          exports: {}
        };
        e[n][0].call(c.exports, function (t) {
          var s = e[n][1][t];
          return a(s ? s : t);
        }, c, c.exports, o, e, t, s);
      }

      return t[n].exports;
    }

    var r = typeof require == "function" && require;

    for (var n = 0; n < s.length; n++) {
      a(s[n]);
    }

    return a;
  }({
    1: [function (e, t, s) {
      "use strict";

      Object.defineProperty(s, "__esModule", {
        value: true
      });

      s["default"] = function (e) {
        function t(e) {
          this._event = e;
          this._data = e.data;
          this.receivedTime = e.receivedTime;

          if (this._data && this._data.length < 2) {
            console.warn("Illegal MIDI message of length", this._data.length);
            return;
          }

          this._messageCode = e.data[0] & 240;
          this.channel = e.data[0] & 15;

          switch (this._messageCode) {
            case 128:
              this.messageType = "noteoff";
              this.key = e.data[1] & 127;
              this.velocity = e.data[2] & 127;
              break;

            case 144:
              this.messageType = "noteon";
              this.key = e.data[1] & 127;
              this.velocity = e.data[2] & 127;
              break;

            case 160:
              this.messageType = "keypressure";
              this.key = e.data[1] & 127;
              this.pressure = e.data[2] & 127;
              break;

            case 176:
              this.messageType = "controlchange";
              this.controllerNumber = e.data[1] & 127;
              this.controllerValue = e.data[2] & 127;

              if (this.controllerNumber === 120 && this.controllerValue === 0) {
                this.channelModeMessage = "allsoundoff";
              } else if (this.controllerNumber === 121) {
                this.channelModeMessage = "resetallcontrollers";
              } else if (this.controllerNumber === 122) {
                if (this.controllerValue === 0) {
                  this.channelModeMessage = "localcontroloff";
                } else {
                  this.channelModeMessage = "localcontrolon";
                }
              } else if (this.controllerNumber === 123 && this.controllerValue === 0) {
                this.channelModeMessage = "allnotesoff";
              } else if (this.controllerNumber === 124 && this.controllerValue === 0) {
                this.channelModeMessage = "omnimodeoff";
              } else if (this.controllerNumber === 125 && this.controllerValue === 0) {
                this.channelModeMessage = "omnimodeon";
              } else if (this.controllerNumber === 126) {
                this.channelModeMessage = "monomodeon";
              } else if (this.controllerNumber === 127) {
                this.channelModeMessage = "polymodeon";
              }

              break;

            case 192:
              this.messageType = "programchange";
              this.program = e.data[1];
              break;

            case 208:
              this.messageType = "channelpressure";
              this.pressure = e.data[1] & 127;
              break;

            case 224:
              this.messageType = "pitchbendchange";
              var t = e.data[2] & 127;
              var s = e.data[1] & 127;
              this.pitchBend = (t << 8) + s;
              break;
          }
        }

        return new t(e);
      };

      t.exports = s["default"];
    }, {}]
  }, {}, [1])(1);
});